import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ApiTemplateConstants } from "../../../constants/api-constants/api-template.constants";
import { SendEmailServiceConstants } from "./send-email-service.constants";
import ODataUtils from "../../../utils/odata.utils";
import { ApiCommunicationConstants } from "../../../constants/api-constants/api-communication.constants";
let SendEmailService = class SendEmailService {
    http;
    componentName = SendEmailServiceConstants.COMPONENT_NAME;
    adHocComms = SendEmailServiceConstants.AD_HOC_COMMS;
    constructor(http) {
        this.http = http;
    }
    postEmail(params) {
        return this.http.post(`${ApiCommunicationConstants.URL}/${ApiCommunicationConstants.FUNCTION_GENERATE_EMAIL}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    postSection49NoticesEmail(params) {
        return this.http.post(`${ApiCommunicationConstants.URL}/${ApiCommunicationConstants.FUNCTION_GENERATE_SECTION_49_NOTICES_EMAIL}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    sendNotice(params) {
        return this.http.post(`${ApiCommunicationConstants.URL}/${ApiCommunicationConstants.FUNCTION_SEND_NOTICE}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    getEmailTemplates(currentStep, moduleId) {
        const params = {
            $expand: "attachment",
            $filter: `stepName eq '${ODataUtils.encryptQueryContent(currentStep)}' and moduleId eq ${moduleId}`
        };
        if (currentStep === this.adHocComms) {
            params.$filter = `moduleId eq ${moduleId}`;
        }
        return this.http.get(ApiTemplateConstants.URL, { params })
            .pipe(map(response => {
            return response;
        }));
    }
    logCommunication(communication, jobId, stepName, stepId) {
        const request = {
            communication,
            jobId,
            stepName,
            stepId
        };
        // const endPointUrl = "api/v2/Communication";
        return this.http.post(`${ApiCommunicationConstants.URL}/${ApiCommunicationConstants.FUNCTION_LOG_COMMUNICATION}`, request)
            .pipe(map(response => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
SendEmailService = __decorate([
    Injectable({
        providedIn: "root"
    })
], SendEmailService);
export { SendEmailService };
